import { render, staticRenderFns } from "./Wasa.vue?vue&type=template&id=32972652&"
import script from "./Wasa.vue?vue&type=script&lang=js&"
export * from "./Wasa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports